import React, { Component } from "react";
import { Box, withStyles } from "@material-ui/core";
import Cookies from "universal-cookie";
import { Link } from "react-router-dom";

const cookies = new Cookies(window.document.cookie);
const styles = (theme) => ({
  link: {
    color: "#676767",
    fontSize: "11px",
    "&:last-child": {
      paddingLeft: "25px",
    },
  },
  copyRight: {
    color: "#676767",
    fontSize: "11px",
  },
  img: {
    paddingLeft: "5px",
  },
});

class FooterNav extends Component {
  render() {
    const { classes, isLoggedIn } = this.props;
    return (
      <>
          <Box display="flex">
            <Box flexGrow={1}>
              {isLoggedIn && (
                <Link to="/faq" className={classes.link}>
                  {" "}
                  FAQ
                </Link>
              )}
              {isLoggedIn && (
                <Link to="/contact" className={classes.link}>
                  {" "}
                  {cookies.get("client") !== "acg" ? "CONTACT" : null}
                </Link>
              )}
            </Box>
            <Box className={classes.copyRight}>
            {cookies.get("client") == "hd" && 
              <Box display="flex" alignItems="center">
                <img
                  src={require("~/assets/images/hd/cashin_logo.png")}
                  className={classes.img}
                  alt=""
                />
                </Box> }
              {cookies.get("client") == "acg" && 
              <Box display="flex" alignItems="center">
                {" "}
                ©2022 ACG Card Services{" "}
                <img
                  src={require("~/assets/images/incedo-logo.jpg")}
                  className={classes.img}
                  alt=""
                />
                </Box> }
                {cookies.get("client") == "bmw" && 
                <Box display="flex" alignItems="center">
                  {" "}
                  ©2022 BMW Group Financial Services Powered by{" "}
                  <img
                    src={require("~/assets/images/incedo-logo.jpg")}
                    className={classes.img}
                    alt=""
                  />         
              </Box>
              }
              {cookies.get("client") == "elan" && 
                <Box display="flex" alignItems="center">
                  {" "}
                  ©2022 ELAN Financial Services Powered by{" "}
                  <img
                    src={require("~/assets/images/incedo-logo.jpg")}
                    className={classes.img}
                    alt=""
                  />         
              </Box>
              }
            </Box>
          </Box>
      </>
    );
  }
}

export default withStyles(styles)(FooterNav);
